// © Sitecore Corporation A/S. All rights reserved. Sitecore® is a registered trademark of Sitecore Corporation A/S.
/* eslint-disable @typescript-eslint/naming-convention */
export var ErrorMessages;
(function (ErrorMessages) {
    ErrorMessages["IV_0006"] = "[IV-0006] Incorrect value for \"timeout\". Set the value to an integer greater than or equal to 0.";
    ErrorMessages["IE_0002"] = "[IE-0002] Timeout exceeded. The server did not respond within the allotted time.";
})(ErrorMessages || (ErrorMessages = {}));
